// Grounded in two real sources rather than invented from scratch:
// - docs/Commercialization_Architecture_Canon.docx, docs/PRC Brand Strategies PandP.docx
// - the actual live copy at nextgengtn.com (headline, subheadline, value prop,
//   founder credential) — pulled in directly so this LMS reads as the same
//   brand voice as the existing marketing site, not a second invented one.
// Still worth a final pass from Abdul/Patrick before this is presentation-ready.

const marketingContent = {
  heroTitle: 'Understanding Commercialization Through Patients + Profitability™',
  heroSubtitle: 'Gross-to-Net (GTN) doesn’t go wrong in the calculations. It goes wrong in the assumptions.',
  heroDescription:
    'Training for Commercial, Market Access, Revenue, and Finance teams to build a shared understanding of commercialization — so operational reality and financial recognition stay aligned. Education before strategy.',
  ctaLabels: {
    primary: 'Sign up',
    secondary: 'Log in',
    catalog: 'Browse courses',
    contact: 'Contact us',
    discoveryCall: 'Book a Discovery Call'
  },
  contactEmail: 'hello@nextgengtn.com',
  valueProp:
    'Patient access and profitability are not separate conversations. They’re interconnected outcomes — the best commercialization strategies improve both.',
  benefits: [
    {
      title: 'Built on one framework, not borrowed theory',
      body: 'Every course traces back to the Six Pillars of Commercialization Architecture — Alignment, Design, Patient Journey, Finance, Intelligence, Transformation — the same framework used in real advisory engagements.'
    },
    {
      title: 'Education before strategy',
      body: "If you're pre-commercial or just past your first launch, you don't need optimization yet — you need the fundamentals: GTN modeling, patient services, market access, hub design, launch readiness."
    },
    {
      title: 'A real test, a real certificate',
      body: 'Self-guided courses end in an actual assessment with a passing score, not a participation badge — so completing one means something.'
    }
  ],
  personas: [
    'Executive Leadership',
    'Commercial Leadership',
    'Market Access',
    'Patient Services',
    'Commercial Finance',
    'Brand Leadership',
    'Launch Teams',
    'Emerging Biotech Leadership'
  ],
  founder: {
    name: 'Patrick Coyle',
    credential: 'Former CFO of a $1.5B+ pharmaceutical business · 30+ years of commercialization experience',
    quote:
      'The best commercialization strategies improve both patient outcomes and business outcomes — that’s the whole philosophy behind Patients + Profitability™.'
  }
};

export default marketingContent;
